import React, { ReactElement } from 'react';
import { Loader } from 'idsk-react-components';
import './vseobecnyObalMaterialu.scss';
import Uuid from '../../../../model/Uuid';
import useVseobecnyObalMaterialuInitData
  from '../../../../page/SprievodnyDokument/ObalMaterialu/hook/useVseobecnyObalMaterialuInitData';
import {
  createObalMaterialuVseobecnyClient,
} from '../../../../client/external/evidencnaaplikacia/obalMaterialuVseobecnyClient';
import VseobecnyObalMaterialu from './VseobecnyObalMaterialu';
import { StadiumMaterialuEnum } from '../../../../model/legislativnyMaterial/StadiumMaterialu';
import { useClient } from '../../../../context/ClientStatusContext';

interface ObalMaterialuProps {
  materialUuid: Uuid,
  type: string,
  year: number,
  index: number,
  stadium: StadiumMaterialuEnum,
  stadiumUuid: Uuid,
}

const VseobecnyObalMaterialuWrapper = ({
  materialUuid, type, year, index, stadium, stadiumUuid,
}: ObalMaterialuProps): ReactElement => {
  const {
    obalInitData,
    initDataStatus,
  } = useVseobecnyObalMaterialuInitData(type, year, index, stadiumUuid, stadium);

  const {
    wrapClient: createObalMaterialuVseobecny,
    status: submitStatus,
  } = useClient(createObalMaterialuVseobecnyClient);

  return (
    <Loader loading={initDataStatus.loading}>
      {obalInitData && (
      <VseobecnyObalMaterialu
        initFormData={obalInitData}
        onSubmitForm={(formData) => createObalMaterialuVseobecny(
          materialUuid,
          formData,
          stadiumUuid,
        )}
        submitStatus={submitStatus}
      />
      )}
    </Loader>
  );
};

export default VseobecnyObalMaterialuWrapper;
